import { createRouter, createWebHistory } from 'vue-router'

import { generateRoutes } from '@/extensions/langRouter/index.js'

const NotFound = () => import('@/views/NotFound.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/:region',
    name: 'region',
    component: () => import('@/views/Region.vue'),
  },
  {
    path: '/communique',
    name: 'press',
    component: () => import('@/views/Press.vue'),
  },
  {
    path: '/politique',
    name: 'policy',
    component: () => import('@/views/Policy.vue'),
  },
  {
    path: '/galerie',
    name: 'gallery',
    component: () => import('@/views/Gallery.vue'),
  },
  {
    path: '/error/404',
    name: 'not-found',
    component: NotFound,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    component: NotFound,
  },
]

const localizedRoutes = generateRoutes(routes, 'fr', 'en')

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: localizedRoutes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: window.innerWidth > 1024 ? 160 : 128,
      }
    }

    return { top: 0 }
  },
})

export default router
